module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-6.cab85389.png";